import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const OportunidadSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        El objetivo
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        No solo estar, sino destacar
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        En una exposición de la magnitud de Expo Petróleo, ser un expositor más no
        es suficiente. Su marca necesita validación editorial, contexto de
        negocios y una pieza audiovisual que convierta la inversión en feria en
        un activo de ventas para el resto del año.
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Transformamos su presencia en feria en una campaña estratégica de 3
        meses, con visibilidad sostenida para que el mensaje no se quede en el
        recinto, sino que siga generando autoridad comercial después del evento.
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        TNO Network despliega su ingeniería de medios en Maracaibo para
        transformar su stand en un set de noticias corporativas mediante
        <strong> visitas de grabación programadas</strong>: vamos al stand, entrevistamos a sus voceros y
        registramos en campo lo que su equipo esté ejecutando en la feria. No grabamos un
        video social; documentamos capacidad técnica, innovación y liderazgo
        frente al ecosistema empresarial del sector hidrocarburos.
      </Typography>

      <Box sx={{ '& > div': { mb: 2 } }}>
        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Validación de liderazgo
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Al ser entrevistado por TNO Business, su empresa deja de ser un
            proveedor más para convertirse en un referente de opinión dentro del
            sector energético.
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Material de proyección
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Entregamos una pieza audiovisual con calidad TNO Network para que
            su equipo comercial la utilice durante todo el año en presentaciones,
            licitaciones y reuniones de negocio.
          </Typography>
        </Box>

        <Box>
          <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
            Huella digital especializada
          </Typography>
          <Typography variant="body2" color="textSecondary">
            La cobertura trasciende el stand: TNO Digest, LinkedIn y señal TNO
            convierten su presencia en feria en posicionamiento sostenido para
            aliados, clientes y competidores durante 3 meses.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default OportunidadSection;
